<template>
    <div class="wrapper-all">
        <div class="wrapper">
            <div>
                <h5 style="margin-bottom: 25px">
                    Your mobile number does not match your CNIC
                </h5>
                <b-form style="margin-bottom: 15px">
                    <radio :field="field"></radio>
                </b-form>
                <p class="paragraph">
                    * Relative includes spouse, dependant parents and dependant
                    children only.
                </p>

                <popup-button
                    btn-type="button"
                    btn-variant="primary"
                    btn-label="Continue"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                    @onClickButton="onClick"
                ></popup-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Radio from '@/components/registration/Radio.vue'
import PopupButton from '@/components/registration/PopupButton.vue'

export default {
    components: {
        Radio,
        PopupButton,
    },
    props: {
        lang: { type: String },
    },
    data() {
        return {
            field: {
                key: 'pmd.recievePmdaOption',
                isLocked: true,
                isRequired: true,
                options: [
                    {
                        text: 'Relative*',
                        value: 'Relative',
                    },
                    {
                        text: 'Company',
                        value: 'Company',
                    },
                ],
                label: 'Select on whose cnic your number is registered',
                urduLabel: 'منتخب کریں جس کی شناختی دستاویز پر آپ کا نمبر رجسٹرڈ ہے',
                title: 'Select on whose cnic your number is registered',
            },
        }
    },
    mounted(){
        if(this.lang == 'urd' ){
            this.field.label = this.field.urduLabel
            console.log("label ", this.field.label)
        }
    },
    methods: {
        onClick() {
            let data = this.$store.state.registration.form.pmd.recievePmdaOption
            console.log('selection', data)
            if (data && data.length && data.length > 0) {
                this.$store.commit('updateField', {
                    key: 'pmdaForm.valid',
                    value: true,
                })
                this.$store.commit('updateField', {
                    key: 'pmd.pmdInfo.idType',
                    value: this.$store.getters.getField('identityInfo.type'),
                })
                this.$store.commit('updateField', {
                    key: 'pmd.pmdInfo.idNumber',
                    value: this.$store.getters.getField('identityInfo.number'),
                })
                this.$store.commit('updateField', {
                    key: 'pmd.pmdInfo.isdCode',
                    value: this.$store.getters.getField('contactInfo.isdCode'),
                })
                this.$store.commit('updateField', {
                    key: 'pmd.pmdInfo.phoneNumber',
                    value: this.$store.getters.getField(
                        'contactInfo.phoneNumber'
                    ),
                })

                this.$emit('selection')
            } else {
                let msg = this.field.title + ' field is required'
                // console.log("error", msg)
                this.$store.commit('setError', msg)
            }
        },
    },

    computed: {
        ...mapGetters(['loading']),
    },
}
</script>

<style scoped>
.wrapper {
    background: #fff;
    display: grid;
    grid-template-rows: 1fr auto;
    overflow-x: hidden;
}
.paragraph {
    font-size: 0.875rem;
    color: #1b1b1e;
    font-family: ProximanovaSemibold;
}
</style>
